/* global moment:true */
/* eslint no-undef: 'error' */

angular
  .module('app', ['ui.router', 'ngResource', 'ngMaterial'])
  .config(function ($mdThemingProvider, $mdDateLocaleProvider) {
    $mdThemingProvider.theme('default')
                      .primaryPalette('teal');
    $mdDateLocaleProvider.formatDate = function (date) {
      return moment(date).format('L');
    };
    $mdDateLocaleProvider.parseDate = function (dateString) {
      var m = moment(dateString, 'L', false);
      return m.isValid() ? m.toDate() : new Date(NaN);
    };
    $mdDateLocaleProvider.months = moment.months();
    $mdDateLocaleProvider.shortMonths = moment.monthsShort();
    $mdDateLocaleProvider.days = moment.weekdays();
    $mdDateLocaleProvider.shortDays = moment.weekdaysShort();
  })
  .constant('config', {
    apiUrl: '/api'
  });


/* global AmCharts:true */
/* global QueryManager:true */
/* eslint no-undef: 'error' */

angular
  .module('app')
  .component('requerimentos', {
    templateUrl: 'app/requerimentos/requerimentos.html',
    controller: RequerimentosController
  });

function RequerimentosController($resource, RequerimentosService) {
  var vm = this;

  function createBar(val) {
    return {
      balloonText: val + ': <b>[[value]]</b>',
      fillAlphas: 0.8,
      lineAlpha: 0.2,
      type: 'column',
      valueField: val
    };
  }

  function filtrarPorClick(event) {
    var item;
    if (event.value) {
      item = event.value;
    } else {
      item = event.item.category;
    }
    item = [item];
    if (vm.tipo === 'estado') {
      vm.query.estados = item;
    } else {
      vm.query.servicos = item;
    }
    vm.update();
  }

  vm.tipo = 'servico';

  var dataInicio = new Date();
  dataInicio.setMonth(dataInicio.getMonth() - 1);

  vm.query = {
    dataInicio: dataInicio,
    dataFim: new Date(),
    estados: [],
    servicos: []
  };

  var mquery = new QueryManager(vm.query);

  vm.estados = [];
  vm.servicos = [];

  RequerimentosService.combos.get(function (response) {
    vm.estados = response.data.estados;
    vm.servicos = response.data.servicos;
  });

  var graphs = [
    createBar('Abertos'), createBar('Pendentes'), createBar('Concluídos')
  ];

  var chartbar = AmCharts.makeChart('barra', {
    type: 'serial',
    theme: 'light',
    rotate: false,
    dataProvider: [],
    valueAxes: [{
      gridColor: '#FFFFFF',
      gridAlpha: 0.2,
      dashLength: 0
    }],
    gridAboveGraphs: true,
    startDuration: 1,
    graphs: graphs,
    chartCursor: {
      categoryBalloonEnabled: false,
      cursorAlpha: 0,
      zoomable: false
    },
    categoryField: 'name',
    categoryAxis: {
      gridPosition: 'start',
      gridAlpha: 0,
      labelRotation: 60,
      tickPosition: 'start',
      tickLength: 20,
      listeners: [{
        event: 'clickItem',
        method: filtrarPorClick
      }]
    },
    export: {
      enabled: false
    }
  });

  chartbar.addListener('clickGraphItem', filtrarPorClick);

  var chartEmAnalise = AmCharts.makeChart('pizzapendentes', {
    type: 'pie',
    theme: 'light',
    dataProvider: [],
    valueField: 'val',
    titleField: 'name',
    balloon: {
      fixedPosition: true
    },
    export: {
      enabled: false
    }
  });

  var chartConcluidos = AmCharts.makeChart('pizzaconcluidos', {
    type: 'pie',
    theme: 'light',
    dataProvider: [],
    valueField: 'val',
    titleField: 'name',
    balloon: {
      fixedPosition: true
    },
    export: {
      enabled: true
    }
  });

  vm.toggleEstados = function () {
    if (vm.query.estados.length === vm.estados.length) {
      vm.query.estados.length = [];
    } else if (vm.query.estados.length >= 0) {
      vm.query.estados = vm.estados.slice(0);
    }
    vm.update();
  };

  vm.estadosIschecked = function () {
    return vm.query.estados.length === vm.estados.length;
  };

  vm.toggleServicos = function () {
    if (vm.query.servicos.length === vm.servicos.length) {
      vm.query.servicos.length = [];
    } else if (vm.query.servicos.length >= 0) {
      vm.query.servicos = vm.servicos.slice(0);
    }
    vm.update();
  };

  vm.servicosIschecked = function () {
    return vm.query.servicos.length === vm.servicos.length;
  };

  vm.resetQuery = function () {
    if (mquery.back()) {
      vm.update();
    }
  };

  vm.update = function () {
    if (vm.query.dataInicio === undefined || vm.query.dataFim === undefined) {
      return false;
    }

    var service = RequerimentosService.servicos;
    if (vm.tipo === 'estado') {
      service = RequerimentosService.estados;
    }
    service.get(vm.query, function (response) {
      chartbar.dataProvider = response.data;
      chartbar.validateData();
    });

    RequerimentosService.pendentes.get(vm.query, function (response) {
      chartEmAnalise.dataProvider = response.data;
      chartEmAnalise.validateData();
    });

    RequerimentosService.concluidos.get(vm.query, function (response) {
      chartConcluidos.dataProvider = response.data;
      chartConcluidos.validateData();
    });
    mquery.save();
  };

  vm.updateAll = function () {
    RequerimentosService.geral.get(function (response) {
      vm.geral = response.data;
    });
    vm.update();
  };

  vm.updateAll();

  setInterval(function () {
    vm.updateAll();
  }, 1 * 60 * 60 * 1000); // 1 hora
}

function QueryManager(query) {
  this.query = query;
  this.historic = [];
}

QueryManager.prototype.save = function () {
  if (this.historic.length > 0 && angular.equals(this.getLast(), this.query)) {
    return;
  }
  var copy = angular.copy(this.query);
  this.historic.push(copy);
};

QueryManager.prototype.back = function () {
  var old = this.pop();
  if (old) {
    angular.extend(this.query, old);
    return true;
  }
  return false;
};

QueryManager.prototype.pop = function () {
  var old = this.historic.pop();
  if (angular.equals(this.query, old)) {
    if (this.historic.length > 0) {
      old = this.historic.pop();
    }
  }
  return old;
};

QueryManager.prototype.getLast = function () {
  return this.historic[this.historic.length - 1];
};



angular
  .module('app')
  .factory('RequerimentosService', function ($resource, config) {
    return {
      geral: $resource(config.apiUrl),
      combos: $resource(config.apiUrl + '/combos'),
      estados: $resource(config.apiUrl + '/estados'),
      servicos: $resource(config.apiUrl + '/servicos'),
      pendentes: $resource(config.apiUrl + '/pendentes'),
      concluidos: $resource(config.apiUrl + '/concluidos')
    };
  });

angular
  .module('app')
  .component('app', {
    templateUrl: 'app/main.html'
  });

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/main.html","<md-toolbar layout=\"row\">\n  <h1 class=\"md-toolbar-tools container\">PAINEL e-SPU</h1>\n</md-toolbar>\n<div ng-cloak>\n  <div md-content class=\"md-padding container\">\n    <requerimentos></requerimentos>\n  </div>\n</div>\n");
$templateCache.put("app/requerimentos/requerimentos.html","<h3>Posição Atual Acumulada</h3>\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" id=\"contadores-geral\">\n  <md-card flex>\n    <md-card-content>\n      <div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\">\n        <div flex>Tempo Médio de Atendimento</div>\n        <div flex class=\"cont\">{{$ctrl.geral.tempo_medio}} dias</div>\n      </div>\n    </md-card-content>\n  </md-card>\n  <md-card flex>\n    <md-card-content>\n      <div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\">\n        <div flex>Número de Requerimentos Pendentes</div>\n        <div flex class=\"cont\">{{$ctrl.geral.pendentes}}</div>\n      </div>\n    </md-card-content>\n  </md-card>\n  <md-card flex>\n    <md-card-content>\n      <div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\">\n        <div flex>Total de Requerimentos</div>\n        <div flex class=\"cont\">{{$ctrl.geral.total}}</div>\n      </div>\n    </md-card-content>\n  </md-card>\n</div>\n<h3>Filtros</h3>\n<md-card>\n  <md-card-content layout=\"row\" layout-xs=\"column\">\n      \n      <md-input-container flex>\n        <label>De</label>\n        <md-datepicker md-open-on-focus ng-model=\"$ctrl.query.dataInicio\" ng-change=\"$ctrl.update()\"></md-datepicker>\n      </md-input-container>\n      <md-input-container flex>\n        <label>Até</label>\n        <md-datepicker md-open-on-focus ng-model=\"$ctrl.query.dataFim\" ng-change=\"$ctrl.update()\"></md-datepicker>\n      </md-input-container>\n      <md-input-container flex>\n        <label>Estados</label>\n        <md-select multiple=\"multiple\" ng-change=\"$ctrl.update()\" ng-model=\"$ctrl.query.estados\">\n          <md-select-header>\n            <div>\n              <md-checkbox value=\"\" ng-click=\"$ctrl.toggleEstados()\" ng-checked=\"$ctrl.estadosIschecked()\">Todos\n            </md-checkbox></div>\n          </md-select-header>\n          <md-optgroup>\n            <md-option ng-repeat=\"estado in $ctrl.estados\" value=\"{{estado}}\">{{estado}}</md-option>\n          </md-optgroup>\n      </md-select></md-input-container>\n      <md-input-container flex>\n        <label>Serviços</label>\n        <md-select multiple=\"multiple\" ng-change=\"$ctrl.update()\" ng-model=\"$ctrl.query.servicos\">\n          <md-select-header>\n            <div>\n              <md-checkbox value=\"\" ng-click=\"$ctrl.toggleServicos()\" ng-checked=\"$ctrl.servicosIschecked()\">Todos\n            </md-checkbox></div>\n          </md-select-header>\n          <md-optgroup>\n            <md-option ng-repeat=\"servico in $ctrl.servicos\" value=\"{{servico}}\">{{servico}}</md-option>\n          </md-optgroup>\n        </md-select>\n      </md-input-container>\n      <md-input-container flex layout=\"row\" layout-align=\"end center\">\n        <md-button class=\"md-warn\" ng-click=\"$ctrl.resetQuery()\">Voltar</md-button>\n      </md-input-container>\n  </md-card-content>\n</md-card>\n\n<md-card>\n  <md-card-content>\n    <md-input-container>\n      <label>Tipo</label>\n      <md-select ng-model=\"$ctrl.tipo\" ng-change=\"$ctrl.update()\">\n        <md-option value=\"servico\">Serviço</md-option>\n        <md-option value=\"estado\">Estado</md-option>\n      </md-select>\n    </md-input-container>\n    <div id=\"barra\"></div>\n  </md-card-content>\n</md-card>\n\n<div layout=\"row\" layout-xs=\"column\">\n\n  <md-card flex>\n    <md-card-title>\n      <md-card-title-text>\n        <span class=\"md-headline\">Pendentes</span>\n      </md-card-title-text>\n    </md-card-title>\n    <md-card-content>\n      <div id=\"pizzapendentes\" class=\"pizza\"></div>\n    </md-card-content>\n  </md-card>\n\n  <md-card flex>\n    <md-card-title>\n      <md-card-title-text>\n        <span class=\"md-headline\">Concluídos</span>\n      </md-card-title-text>\n    </md-card-title>\n    <md-card-content>\n      <div id=\"pizzaconcluidos\" class=\"pizza\"></div>\n    </md-card-content>\n  </md-card>\n\n</div>\n");}]);
angular
  .module('app')
  .config(routesConfig);

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
  $locationProvider.html5Mode(true).hashPrefix('!');
  $urlRouterProvider.otherwise('/');

  $stateProvider
    .state('app', {
      url: '/',
      component: 'app'
    });
}
